import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './electronicInvoice.json';

const getValueAddedInvoiceSettingInitData = (req, res, ctx) => {
  return res(
    ctx.json(
      mockResponse(apiResponses['electronicInvoiceController/getValueAddedInvoiceSettingInitData'].success.default)
    )
  );
};
const getCarrierInvoiceSettingInitData = (req, res, ctx) => {
  return res(
    ctx.json(mockResponse(apiResponses['electronicInvoiceController/getCarrierInvoiceSettingInitData'].success.default))
  );
};

export const handlers = [
  rest.post(
    getApiEndpoint('electronicInvoiceController/getValueAddedInvoiceSettingInitData'),
    withScenario(withAuthCheck(getValueAddedInvoiceSettingInitData))
  ),
  rest.post(
    getApiEndpoint('electronicInvoiceController/getCarrierInvoiceSettingInitData'),
    withScenario(withAuthCheck(getCarrierInvoiceSettingInitData))
  ),
];
